import { withTranslation } from 'react-i18next';

import Loading from '../../../../components/Loading';
import MetricCards from '../../GscTools/components/MetricCards';
import PeriodTrend from '../../GscTools/components/PeriodTrend';
import { comparability, metricsFor } from '../../GscTools/metrics';

/**
 * Block 03 — the active topic's daily series, its baseline aligned by day behind it.
 *
 * Fetched with the identical filters block 02 used, each window separately, so a baseline that
 * fails leaves the current line drawn and says so. Days Search Console did not return stay gaps,
 * and the queries it withheld are not drawn as an "unclassified" line beside the topic: there is
 * no figure for them, only the knowledge that they exist.
 *
 * The cards are summed from the days that came back, so they and the line are the same figures;
 * they can differ slightly from the topic's row above, which is one aggregate for the window.
 */
function TopicTrend({
    t,
    scope,
    topic,
    status,
    error,
    baselineError,
    current,
    baseline,
    metric,
    onMetric,
}) {
    const comparison = comparability(current?.coverage, baseline?.coverage ?? null);

    return (
        <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
            <div className="card-header d-flex justify-content-between">
                <div>
                    <p className="card-title">
                        03 ·{' '}
                        {topic
                            ? t('tools.topic_clusters.trend.title', { topic })
                            : t('tools.topic_clusters.trend.title_idle')}
                    </p>
                    <p className="gsc-tool-sub">{t('tools.topic_clusters.trend.description')}</p>
                </div>
            </div>

            <div className="card-body">
                {!topic && (
                    <div className="gsc-tool-load-state">
                        <span className="gsc-tool-load-icon" aria-hidden="true">
                            <i className="icon-area-chart" />
                        </span>
                        <h4>{t('tools.topic_clusters.trend.idle_title')}</h4>
                        <p>{t('tools.topic_clusters.trend.idle')}</p>
                    </div>
                )}

                {!!topic && status === 'loading' && <Loading padding={20} />}

                {!!topic && status === 'error' && (
                    <div className="gsc-tool-banner error">
                        {error ?? t('global.something_went_wrong')}
                    </div>
                )}

                {!!topic && status === 'done' && (
                    <>
                        {!!baselineError && (
                            <div className="gsc-tool-banner error">
                                {t('tools.topic_clusters.trend.baseline_failed', {
                                    reason: baselineError,
                                })}
                            </div>
                        )}

                        <MetricCards
                            metrics={metricsFor(scope.searchType)}
                            totals={current?.totals}
                            priorTotals={baseline?.totals}
                            comparison={comparison}
                            selectedMetric={metric}
                            onSelectMetric={onMetric}
                        />

                        <p className="gsc-tool-hint">{t('tools.topic_clusters.trend.pick_card')}</p>

                        <PeriodTrend
                            metric={metric}
                            current={current}
                            baseline={baseline}
                            fileName={t('tools.topic_clusters.trend.title', { topic })}
                        />

                        <p className="gsc-tool-table-note">
                            {t('tools.topic_clusters.trend.sum_note')}
                        </p>
                        <p className="gsc-tool-table-note">
                            {t('tools.topic_clusters.trend.gaps_note')}
                        </p>
                    </>
                )}
            </div>
        </div>
    );
}

export default withTranslation()(TopicTrend);
